import { render, staticRenderFns } from "./card_compromisso.vue?vue&type=template&id=b063952a&scoped=true"
import script from "./card_compromisso.vue?vue&type=script&lang=js"
export * from "./card_compromisso.vue?vue&type=script&lang=js"
import style0 from "./card_compromisso.vue?vue&type=style&index=0&id=b063952a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063952a",
  null
  
)

export default component.exports